module.exports = require("@swa-ui/dotcom/src/placements/LuvStoriesPlacement/LuvStoryCard/LuvStoryCard.module.scss");